/**
 * React component that is responsible for rendering a simple Hero with a background image/color.
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react';
import PropTypes from 'prop-types'
import cx from 'classnames'
import { BasicSection } from 'components/CTASections'
import styles from './SimpleHero.module.scss'

const SimpleHero = ({ children, ...props }) => (
  <BasicSection
    {...props}
    className={cx(props.className, styles.hero, {
      'py-2xl': !props.className,
    })}
    align="center"
    titleSettings={{
      className: cx(styles.heroHeadline),
      variant: 'h1',
    }}>
    {children}
  </BasicSection>
)

SimpleHero.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
}

export default SimpleHero
